export default __webpack_public_path__ + "static/bar-with-labels-208cd9fd548596dfe26b408a799dae5d.png";